var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-template-sidebar'),_c('div',{staticClass:"main-content"},[_c('main-template-topbar'),_c('router-view')],1),_c('portal-target',{attrs:{"name":"modals"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }